// VoiceSpectrum.Web.T2 · pages/SupportEntryPage.tsx · v12.10.9.4 (#1365 keeps the way back to the console for this visit) · 2026-10-07 · VoiceSpectrum AI
// VoiceSpectrum.Web.T2 · pages/SupportEntryPage.tsx · v12.10.9.3 (#1329) · 2026-10-07 · VoiceSpectrum AI
// /support-entry#code=...&back=...&name=...&from=... - where "Open as VoiceSpectrum Support" (Support Ops / Platform Ops)
// lands. The one-time code (60 seconds, used once) is swapped for the support visit's sign-in, then the practice opens with
// the purple banner. Everything rides in the # part of the address, so it never reaches a server log.
import { useEffect, useState } from 'react';
import { api, setToken } from '../lib/api';
import { clearSupportVisit, safeBack, saveSupportVisit } from '../lib/supportVisit';

export default function SupportEntryPage() {
  const [error, setError] = useState<string | null>(null);
  useEffect(() => {
    const h = new URLSearchParams(window.location.hash.replace(/^#/, ''));
    const code = h.get('code');
    const back = safeBack(h.get('back'));
    history.replaceState(null, '', '/support-entry');   // the code is spent - don't keep it in the address bar
    if (!code) { setError('This link is missing its code. Open the practice again from the console.'); return; }
    api.post<{ accessToken: string }>('/auth/support-entry', { code })
      .then((r) => {
        // v12.10.9.4 (#1365): only after the code worked - where Leave / an ended visit goes back to
        if (back) saveSupportVisit({ back, name: h.get('name') || 'The practice', from: h.get('from') || 'the console' });
        else clearSupportVisit();
        setToken(r.accessToken);
        window.location.replace('/');
      })
      .catch(() => setError('This link has expired or was already used. Open the practice again from the console.'));
  }, []);
  return (
    <div className="tenant-page" style={{ display: 'grid', placeItems: 'center', minHeight: '100vh' }}>
      <section className="tenant-empty" style={{ textAlign: 'center' }}>
        <h1>{error ? 'Could not open the practice' : 'Opening as VoiceSpectrum Support…'}</h1>
        {error && <p>{error}</p>}
      </section>
    </div>
  );
}
